export enum DeliveryStatusDashboard {
  GET_DELIVERY_STATUS_LIST = "GET_DELIVERY_STATUS_LIST",
  GET_DELIVERY_STATUS_LIST_SUCCESS = "GET_DELIVERY_STATUS_LIST_SUCCESS",
  GET_DELIVERY_STATUS_LIST_FAIL = "GET_DELIVERY_STATUS_LIST_FAIL",

  GET_DASHBOARD_STATUS_DETAILS = "GET_DASHBOARD_STATUS_DETAILS",
  GET_DASHBOARD_STATUS_DETAILS_SUCCESS = "GET_DASHBOARD_STATUS_DETAILS_SUCCESS",
  GET_DASHBOARD_STATUS_DETAILS_FAIL = "GET_DASHBOARD_STATUS_DETAILS_FAIL",
}
